import React from 'react';
import styled from 'styled-components';
import { FaFilePdf, FaDownload } from 'react-icons/fa';

const PDFContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  margin-bottom: 1rem;
  background-color: ${({ theme }) => theme.colors.lightBackground};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: rgba(74, 144, 226, 0.1);
  }
`;

const PDFIcon = styled.div`
  color: ${({ theme }) => theme.colors.error};
  font-size: 1.5rem;
  margin-right: 1rem;
`;

const PDFInfo = styled.div`
  flex-grow: 1;
`;

const PDFTitle = styled.h4`
  margin: 0 0 0.25rem 0;
  color: ${({ theme }) => theme.colors.text};
`;

const PDFDescription = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.lightText};
`;

const DownloadButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-decoration: none;
  
  svg {
    margin-right: 0.5rem;
  }
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary};
    color: white;
  }
`;

const PDFLink = ({ title, description, pdfUrl }) => {
  // If it's a Sanity URL (starts with https), use it directly
  // If it's a local path, convert it to public folder path
  const correctPdfUrl = pdfUrl.startsWith('https') 
    ? pdfUrl 
    : pdfUrl.replace('/src/assets/pdfs/', '/pdfs/');
    
  return (
    <PDFContainer>
      <PDFIcon>
        <FaFilePdf />
      </PDFIcon>
      <PDFInfo>
        <PDFTitle>{title}</PDFTitle>
        {description && <PDFDescription>{description}</PDFDescription>}
      </PDFInfo>
      <DownloadButton 
        href={correctPdfUrl} 
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaDownload /> View PDF
      </DownloadButton>
    </PDFContainer>
  );
};

export default PDFLink;
